angular.module("acl.visualizer.multiSelect").directive("aclPopoverContent", function() {
  return {
    restrict: "E",
    replace: true,
    templateUrl: "visualizer/js/modules/core/multiSelect/popoverContent.tpl.html",
  };
});
